import { useEffect, useRef } from 'react';

export interface EscToCloseTarget {
  open: boolean;
  close: () => void;
}

export function useEscToClose(getTargets: () => EscToCloseTarget[]) {
  const targetsRef = useRef(getTargets);
  targetsRef.current = getTargets;

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key !== 'Escape') return;
      for (const target of targetsRef.current()) {
        if (target.open) {
          event.preventDefault();
          target.close();
          break;
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
